import styled, {keyframes} from "styled-components";

const shimmer = keyframes`
  0% {
    background-position: -200% 0;
    opacity: 1;
  }
  25% {
    opacity: 1;
  }
  50% {
    background-position: 200% 0;
    opacity: 1;
  }
  100% {
    opacity: 1;
  }
`;

export const StyledAppSelect = styled.div`
    /* display: flex;
    align-items:center; */
    width: 100%;
    .MuiOutlinedInput-root {
        background-color:${(p) => p.theme.colors.white02};
        font-size: 1.4rem;
        font-family: ${(p) => p.theme.fontFamily.NotoSansJP_500};
        font-weight: 500;
        border-radius: 24px;;
        height:40px;
    }
    .MuiOutlinedInput-input {
        padding: 0.8rem;
    }
    .MuiMenuItem-root {
        justify-content: flex-start !important;
        text-align: left;
        display: none;
    }
    svg {
        margin-right: 2rem;
        cursor: pointer;
    }
    .MuiAvatar-root {
        width: 3rem;
        height: 3rem;
    }
    .colorIcon {
        height: 2rem;
        width: 2rem;
        border-radius: 100%;
        margin-right: 1rem;
    }
    .MuiMenuItem-root {
        padding: 1rem 0;
    }
`;
export const Placeholder = styled.div`
    color: #c6c6c7;
`;
export const StyledAppMultipleSelect = styled.div`
    width: 100%;
    max-width: 40rem;
    .MuiOutlinedInput-root {
        font-size: 1.4rem;
        font-family: ${(p) => p.theme.fontFamily.NotoSansJP_500};
        font-weight: 500;
        border-radius: 1.6rem;
        width: 100%;
    }
    .MuiOutlinedInput-input {
        padding: 1.2rem;
    }
    svg {
        margin-right: 2rem;
        cursor: pointer;
    }
`;
export const StyledSelectInputChipBox = styled.div`
    display: flex;
    flex-wrap: wrap;
    .chip {
        &__select {
            margin-left: 0.5rem;
            margin-bottom: 0.5rem;
            font-size: 1.4rem;
        }
        .MuiChip-label {
        }
    }
`;
export const StyledAppCustomSelect = styled.div`
    // z-index: 1;
    position: relative; /* so the overlay can be absolutely positioned */

    .filter {
      &__single-value{
        .MuiAvatar-root{
          display: none;
          }
          }
          &__menu {
            margin: 0.125rem auto;
            font-size: 1.2rem;
            z-index: 100;
            }
            &__control{
            background-color:${(p) => p.theme.colors.white02};
            border-radius: 24px;
        }
        &__option {
            min-height: 1rem;
            font-size: 14px;
            &--is-focused {
                background-color: lightblue;
            }

        }

        &__group {
            padding: 0;
        }

        &__menu-portal {
            border: 1px solid white;
        }
        &__multi-value__label{
            font-size: 1.4rem;
        }
        &__placeholder,&__input{
            font-size: 1.4rem !important;
        }
    }

    .loading-overlay {
        position: absolute;
        inset: 0; /* top:0, right:0, bottom:0, left:0 */
        border-radius: 2rem;
        overflow: hidden;
        pointer-events: none; /* don't block clicking the select */

        background: linear-gradient(
        90deg,
        /*#33669944 0%,*/
        #33333344 0%,
        /*#4a7fb844 25%,*/
        #44444444 25%,
        #82828244 50%,
        /*#4a7fb844 75%,*/
        #44444444 75%,
        /*#33669944 100%*/
        #33333344 100%
        );
        background-size: 200% 100%;

        animation: ${shimmer} 2s ease-in-out infinite;
    }
`;
export const StyledAppCustomeOption = styled.div`
    display: flex;
    .optionName{
        padding-left: 1rem;
        display: flex;
        align-items: center;
    }
    .default{
        background-color: gray;
        color: black;
    }
`;
export const StyledAppCustomLiveletSelect = styled.div`
    // z-index: 1;
    .filter__option--is-create {
    display: none !important;
    }
    .filter {
      &__single-value{
        .MuiAvatar-root{
          display: none;
          }
          }
          &__menu {
            margin: 0.125rem auto;
            font-size: 1.2rem;
            z-index: 100;
            }
            &__control{
            background-color:${(p) => p.theme.colors.white02};
            border-radius: 24px;
        }
        &__option {
            min-height: 1rem;
            font-size: 14px;
            &--is-focused {
                background-color: lightblue;
            }

        }

        &__group {
            padding: 0;
        }

        &__menu-portal {
            border: 1px solid white;
        }
        &__multi-value__label{
            font-size: 1.4rem;
        }
        &__placeholder,&__input{
            font-size: 1.4rem !important;
        }
    }
`;
